<template>
  <div>
    <b-card class="card-expense-list border-0">
      <b-card-header class="bg-transparent p-2 border-0">
        <div class="d-flex justify-content-between align-items-center">
          <h3 class="mb-0">รายการใช้จ่าย</h3>
          <b-button
            size="sm"
            pill
            variant="outline-info"
            class="d-flex align-items-center"
            @click="isVisible = true">
            เพิ่มรายการ <b-icon icon="plus"></b-icon>
          </b-button>
        </div>
      </b-card-header>
      <b-card-body>
        <b-row class="text-center">
          <b-col cols="12" class="my-5">
            <!-- <span class="h5">คุณยังไม่มีรายการใช้จ่าย</span> -->
            <TableExpenses ref="expenses" :jobId="jobId" />
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <SidebarExpenses
      :isVisible.sync="isVisible"
      @getExpenses="$refs.expenses.getJobExpensesDriver(1, jobId)" />
  </div>
</template>

<script>
import TableExpenses from "@/components/Job/TableExpenses.vue";
import SidebarExpenses from "@/components/Job/SidebarExpenses.vue";

export default {
  props: {
    jobId: {
      default: true,
    },
  },
  components: { TableExpenses, SidebarExpenses },
  data() {
    return {
      isVisible: false,
    };
  },
};
</script>
